/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_New_Term_Added_ToastInputs */



/**
* | output |
* | --- |
* | "New term added" |
*
* @param {Knp_Lookup_New_Term_Added_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_new_term_added_toast = /** @type {((inputs?: Knp_Lookup_New_Term_Added_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_New_Term_Added_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau terme ajoute")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Begriff hinzugefügt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo termine aggiunto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавлен новый термин")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo término añadido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新增术语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい用語が追加されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया शब्द जोड़ा गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo termo adicionado")
	return /** @type {LocalizedString} */ ("New term added")
});